import { type PropsWithChildren, createContext, useContext, useMemo } from 'react';

const DEFAULT_BASE = '/v2/signin';

export type AuthRoutePaths = {
  signIn: string;
  verify: string;
  continueWithEmail: string;
  signUp: string;
};

export type AuthRouteBaseValue = {
  basePath: string;
  paths: AuthRoutePaths;
};

function buildPaths(basePath: string): AuthRouteBaseValue {
  const normalized = (basePath || DEFAULT_BASE).replace(/\/$/, '') || DEFAULT_BASE;
  return {
    basePath: normalized,
    paths: {
      signIn: normalized,
      verify: `${normalized}/verify`,
      continueWithEmail: `${normalized}/continuewithemail`,
      signUp: `${normalized}/signup`,
    },
  };
}

const defaultValue = buildPaths(DEFAULT_BASE);

const AuthRouteBaseContext = createContext<AuthRouteBaseValue | null>(null);

export function AuthRouteBaseProvider({
  basePath,
  children,
}: PropsWithChildren<{ basePath: string }>) {
  const value = useMemo(() => buildPaths(basePath), [basePath]);
  return <AuthRouteBaseContext.Provider value={value}>{children}</AuthRouteBaseContext.Provider>;
}

export function useAuthRouteBase(): AuthRouteBaseValue {
  const ctx = useContext(AuthRouteBaseContext);
  return ctx ?? defaultValue;
}
